<div class="filter" [class.filter-padded-left]="!tier.uniqueTier && !tier.chanceBaseTier" style="margin-bottom: 0px!important;">
  <div class="filter full-span" [class.disabled]="disabled">
    @if (tier.uniqueTier || tier.chanceBaseTier) {
      <span class="input-group-btn">
        <button class="btn toggle-btn" [class.off]="!tier.displayOptions.active" (click)="toggleTierActive()"></button>
      </span>
    }

    <span class="filter-body">
      @if (tier.uniqueTier) {
        <div class="filter-title" style="width: 100% !important">
          <strong><span class="filter-title-text">{{ tier.uniqueTier }}</span></strong> -
          @if (!active) {
            @if (filter.hideAllRemainingUniques) {
              <span class="filter-title-text">Hidden {{ isMobile() ? '' : ' (Remaining Uniques)' }}</span>
            } @else {
              <span class="filter-title-text">Disabled (visible)</span>
            }
          } @else if (tier.displayOptions.hidden) {
            <span class="filter-title-text">Hidden</span>
          } @else {
            <span class="filter-title-text">{{ (tier.displayOptions.cosmeticOptions?.highlight ? (tier.displayOptions.cosmeticOptions?.highlightColor + (isMobile() ? '' : ' highlight' ) ) : 'Visible' + (isMobile() ? '' : ', no highlight')) }}</span>
          }
        </div>
        @if (defaultUniqueTierCutoffValues?.[tier.uniqueTier!]) {
          <span class="sep hidden-on-mobile"></span>
          <div class="filter-title filter-label hidden-on-mobile" style="min-width: 80px !important; text-align: right !important;">
            {{ defaultUniqueTierCutoffValues?.[tier.uniqueTier!]?.priceLabel }}
            <img [src]="defaultUniqueTierCutoffValues?.[tier.uniqueTier!]?.priceBaseCurrencyImage ? imgPrefix + defaultUniqueTierCutoffValues?.[tier.uniqueTier!]?.priceBaseCurrencyImage : ''" [alt]="defaultUniqueTierCutoffValues?.[tier.uniqueTier!]?.priceBaseCurrency" class="base-type-image">
          </div>
        }
      } @else if (tier.chanceBaseTier) {
        <div class="filter-title" style="width: 100% !important">
          <strong><span class="filter-title-text">{{ tier.chanceBaseTier === 'Searching' ? 'Favourite' : tier.chanceBaseTier }}</span></strong> -
          @if (!active) {
            <span class="filter-title-text"> Disabled</span>
          } @else if (tier.displayOptions.hidden) {
            <span class="filter-title-text"> Hidden</span>
          } @else {
            <span class="filter-title-text">{{ (tier.displayOptions.cosmeticOptions?.highlight ? (tier.displayOptions.cosmeticOptions?.highlightColor + (isMobile() ? '' : ' highlight' ) ) : 'Visible' + (isMobile() ? '' : ', no highlight')) }}</span>
          }
        </div>
      } @else {
        <div class="filter-title" style="width: 100% !important">
          <strong><span class="filter-title-text">{{ tier.tier + '-Tier' }}</span></strong> -
          @if (!active) {
            <span class="filter-title-text">Disabled (visible)</span>
          } @else if (tier.displayOptions.hidden) {
            <span class="filter-title-text"> Hidden</span>
          } @else {
            <span class="filter-title-text">{{ (tier.displayOptions.cosmeticOptions?.highlight ? (tier.displayOptions.cosmeticOptions?.highlightColor + (isMobile() ? '' : ' highlight' ) ) : 'Visible' + (isMobile() ? '' : ', no highlight')) }}</span>
          }
        </div>
        @if (!equipment) {
          <span class="sep hidden-on-mobile"></span>
          <div class="filter-title filter-label hidden-on-mobile" style="min-width: 80px !important; text-align: right !important;">
            <span class="filter-title-text">
              {{ defaultTierCutoffValues?.[tier.tier!]?.priceLabel }}
              <img [src]="defaultTierCutoffValues?.[tier.tier!]?.priceBaseCurrencyImage ? imgPrefix + defaultTierCutoffValues?.[tier.tier!]?.priceBaseCurrencyImage : ''" [alt]="defaultTierCutoffValues?.[tier.tier!]?.priceBaseCurrency" class="base-type-image">
            </span>
          </div>
        }
      }

      @if (!equipment && !tier.uniqueTier && !tier.chanceBaseTier) {
        <span class="sep"></span>
        <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active || disabled">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [disabled]="!active || disabled" [class.off]="!tier.displayOptions.hidden" (click)="tier.displayOptions.hidden = !tier.displayOptions.hidden; dirtyForceUpdate = dirtyForceUpdate + 1; updateFilter();"></button>
          </span>
          <span class="table-checkbox-label">
            <span class="filter-title-text">Hide</span>
          </span>
        </div>
      }

      <span class="sep"></span>
      <span style="display: table;" app-cosmetic-controls
        [disabled]="!active || tier.displayOptions.hidden || disabled || false"
        [controls]="cosmeticControls"
        [displayable]="tier"
        [forceHidden]="(tier.uniqueTier && !tier.displayOptions.active && filter.hideAllRemainingUniques)"
        [isCurrency]="tier.uniqueTier || tier.chanceBaseTier || equipment ? false : true"
        [isDivinationCard]="divCard"
        [rarity]="tier.uniqueTier ? Rarity.Unique : tier.chanceBaseTier ? Rarity.Normal : undefined"
        [exampleName]="isMobile() ? 'Example' : tier.uniqueTier ? 'Example Unique' : tier.chanceBaseTier ? 'Example' : divCard ? 'Example Card' : equipment ? 'Example Item' : 'Example Orb'"
        [dirtyForceUpdate]="dirtyForceUpdate"
        (updateFilter)="updateFilter()"
      >
      </span>
      <span class="input-group-btn">
        <app-cosmetic-style-options-menu
          [disabled]="!active || tier.displayOptions.hidden || disabled || false"
          [getCopyOptions]="getTierCopyOptions"
          [getCopyNameHint]="getTierCopyNameHint"
          [applyPaste]="pasteStyle"
          [exampleName]="isMobile() ? 'Example' : tier.uniqueTier ? 'Example Unique' : tier.chanceBaseTier ? 'Example' : divCard ? 'Example Card' : equipment ? 'Example Item' : 'Example Orb'"
          [rarity]="tier.uniqueTier ? Rarity.Unique : tier.chanceBaseTier ? Rarity.Normal : undefined"
          [isCurrency]="tier.uniqueTier || tier.chanceBaseTier || equipment ? false : true"
          [isDivinationCard]="divCard"
          [forceHidden]="(tier.uniqueTier && !tier.displayOptions.active && filter.hideAllRemainingUniques)">
          <button type="button" class="btn options-menu-item" (click)="resetToDefaults()">
            <span class="icon icon-loop2 options-menu-icon" aria-hidden="true"></span>
            <span class="options-menu-label">Reset to Defaults</span>
          </button>
        </app-cosmetic-style-options-menu>
      </span>
    </span>
  </div>
  <app-cosmetic-settings style="display: table;"
    [cosmeticOptions]="tier.displayOptions.cosmeticOptions!"
    [cosmeticControls]="cosmeticControls"
    [active]="!disabled"
    filterClasses="filter-padded"
    (updateFilter)="updateFilter()"
    >
  </app-cosmetic-settings>
</div>
